/*
 * @Author: xuejian3721
 * @Date: 2024-04-16 16:42:34
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-12-13 11:48:04
 */
import store from '@/store'
import { Message } from 'element-ui'

// 每次取的数据数量
const itemsPerPage = 5

// 当前显示数据的起始索引
let startIndex = 0

// 设置问答样式-分类
export function setQaStyle(isFlag = false) {
  if (isFlag) startIndex = 0
  const qaList = store.state.chat.qaList || []
  const num = qaList.length > 5
  // 如果 startIndex 超过了 qaList 的长度，则重置为 0
  startIndex = startIndex >= qaList.length ? 0 : startIndex
  // 计算结束索引
  const endIndex = Math.min(startIndex + itemsPerPage, qaList.length)
  const newData = qaList.slice(startIndex, endIndex)
  // 更新 startIndex 为下一次点击时的起始索引
  startIndex = endIndex
  const content =
    newData && newData.length > 0
      ? store.state.mobile
        ? mobileClassifyStyle(newData, num)
        : pcClassifyStyle(newData, num)
      : ''
  return content
}

function mobileClassifyStyle(qaList, num) {
  const { imageSrc, background } = getStyleResources()

  let html = ''
  qaList.forEach((item, index) => {
    html += `<div style="line-height: 36px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;"
        onclick="replyByClassify('${item.questionPlanId},${item.questionPlanClassificationId}')">
        <div style="display: inline-block;font-size: 13px;color: #111111;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.classificationName}</div>
        <img style="width:10px;height: 10px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  let exchange = ''
  if (num) {
    exchange = `<div style="width: 56px;height: 27px;font-size: 11px;color: #FF0000;border: 1px solid #FF0000;border-radius: 24px;cursor: pointer;display:flex;align-items: center;justify-content: center;"
        onclick="exchange()">换一换</div>`
  }
  return `<div class="msg-card-qa" style="min-width: 272px;box-sizing: border-box; display: flex;min-height:${
    num ? '196px' : '71px'
  }">
    <div style="width: 71px;display: flex;flex-direction: column;justify-content: space-between;align-items: center;padding: 15px 0;background-size: cover;background-position: center;border-radius: 21px 0 0 21px;
    background-image: url(${background});">
      <img style="width:37px;height: 38px;" src="${imageSrc}" alt="" />
     ${exchange}
    </div>
    <div style="flex: 1;padding: 8px 14px;background-color:#ffffff;border-radius: 0 21px 21px 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    ${html}
    </div>
  </div>`
}

function pcClassifyStyle(qaList, num) {
  const { imageSrc, background } = getStyleResources()
  let html = ''
  qaList.forEach((item, index) => {
    html += `<div style="line-height: 37px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;border-bottom: 1px solid #F6F8FA;padding: 0 8px;"
        onclick="replyByClassify('${item.questionPlanId},${item.questionPlanClassificationId}')">
        <div style="display: inline-block;font-size: 14px;color: #333333;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.classificationName}</div>
        <img style="width:16px;height: 16px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  let exchange = ''
  if (num) {
    exchange = `<div style="width: 66px;height:24px; font-size: 12px;color: #666666;background-color: #fff;border-radius: 24px;display:flex;align-items: center;justify-content: space-evenly;cursor: pointer;"
          onclick="exchange()"><img style="width:12px;height: 12px;" src="https://s.yyjzt.com/kf-web/20240416/171326563193835fa.png"/>换一换</div>`
  }
  return `<div class="msg-card-qa" style="min-width: 324px;box-sizing: border-box;display: flex;flex-direction: column;border-radius: 0 20px 20px 20px;background: ${background};min-height:${
    num ? '254px' : '102px'
  }">
    <div style="height: 52px; margin: 0 12px; display: flex; align-items: flex-end;">
      <img style="width:44px;height: 49px;" src="${imageSrc}" alt="" />
      <div style="flex: 1; display: flex; align-items: flex-end;justify-content: space-between;padding: 0 0 8px 10px;">
        <img style="width:98px;height: 27px;" src="https://s.yyjzt.com/kf-web/20240416/1713254119606f048.png" alt="" />
        ${exchange}
      </div>
    </div>
    <div style="flex:1; margin: 0 12px 12px;background-color: #fff;border-radius: 8px;">
    ${html}
    </div>
  </div>`
}

// 设置问答样式-问题
export function setQuestionStyle(msgId) {
  // 判断msgId有没有被存储过，如果被存储过，拿到当前msgId缓存的数据
  const questionCache = store.state.chat.questionCache || {}
  const foundValue = questionCache[msgId]
  if (Object.keys(foundValue).length > 0) {
    const { startIndex, qaList } = foundValue
    const num = qaList.length > 5
    // 如果 startIndex 超过了 qaList 的长度，则重置为 0
    const index = startIndex >= qaList.length ? 0 : startIndex
    // 计算结束索引
    const endIndex = Math.min(index + itemsPerPage, qaList.length)
    const newData = qaList.slice(index, endIndex)

    // 更新 startIndex 为下一次点击时的起始索引
    store.commit('chat/setQuestionCache', { msgId, startIndex: endIndex, qaList })

    const content =
      newData && newData.length > 0
        ? store.state.mobile
          ? mobileQuestionStyle(newData, num, msgId)
          : pcQuestionStyle(newData, num, msgId)
        : ''
    return content
  } else {
    Message.warning('数据切换异常')
  }
}

function mobileQuestionStyle(qaList, num, msgId) {
  const { imageSrc, background } = getStyleResources()
  let html = ''
  qaList.forEach((item, index) => {
    html += `<div style="line-height: 36px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;"
        onclick="replyByQuestion('${item.questionId},${item.questionPlanId},${item.questionPlanClassificationId}')">
        <div style="display: inline-block;font-size: 13px;color: #111111;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.questionName}</div>
        <img style="width:10px;height: 10px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  let exchange = ''
  if (num) {
    exchange = `<div style="width: 56px;height: 27px;font-size: 11px;color: #FF0000;border: 1px solid #FF0000;border-radius: 24px;cursor: pointer;display:flex;align-items: center;justify-content: center;"
        onclick="exQuestionChange('${msgId}')">换一换</div>`
  }
  return `<div class="msg-card-qa" style="min-width: 272px;box-sizing: border-box; display: flex;min-height:${
    num ? '196px' : '71px'
  }">
    <div style="width: 71px;display: flex;flex-direction: column;justify-content: space-between;align-items: center;padding: 15px 0;background-size: cover;background-position: center;border-radius: 21px 0 0 21px;
    background-image: url(${background});">
      <img style="width:37px;height: 38px;" src="${imageSrc}" alt="" />
     ${exchange}
    </div>
    <div style="flex: 1;padding: 8px 14px;background-color:#ffffff;border-radius: 0 21px 21px 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    ${html}
    </div>
  </div>`
}

function pcQuestionStyle(qaList, num, msgId) {
  const { imageSrc, background } = getStyleResources()
  let html = ''
  qaList.forEach((item, index) => {
    html += `<div style="line-height: 37px;display: flex;justify-content: space-between;align-items: center;cursor: pointer;border-bottom: 1px solid #F6F8FA;padding: 0 8px;"
        onclick="replyByQuestion('${item.questionId},${item.questionPlanId},${item.questionPlanClassificationId}')">
        <div style="display: inline-block;font-size: 14px;color: #333333;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">${item.questionName}</div>
        <img style="width:16px;height: 16px;" src="https://s.yyjzt.com/kf-web/20240416/171325412224226e9.png" alt="" />
      </div>`
  })
  let exchange = ''
  if (num) {
    exchange = `<div style="width: 66px;height:24px; font-size: 12px;color: #666666;background-color: #fff;border-radius: 24px;display:flex;align-items: center;justify-content: space-evenly;cursor: pointer;"
          onclick="exQuestionChange('${msgId}')"><img style="width:12px;height: 12px;" src="https://s.yyjzt.com/kf-web/20240416/171326563193835fa.png"/>换一换</div>`
  }
  return `<div class="msg-card-qa" style="min-width: 324px;box-sizing: border-box;display: flex;flex-direction: column;border-radius: 0 20px 20px 20px;background: ${background};min-height:${
    num ? '254px' : '102px'
  }">
    <div style="height: 52px; margin: 0 12px; display: flex; align-items: flex-end;">
      <img style="width:44px;height: 49px;" src="${imageSrc}" alt="" />
      <div style="flex: 1; display: flex; align-items: flex-end;justify-content: space-between;padding: 0 0 8px 10px;">
        <img style="width:98px;height: 27px;" src="https://s.yyjzt.com/kf-web/20240416/1713254119606f048.png" alt="" />
        ${exchange}
      </div>
    </div>
    <div style="flex:1; margin: 0 12px 12px;background-color: #fff;border-radius: 8px;">
    ${html}
    </div>
  </div>`
}

// 主题资源
function getStyleResources() {
  const deviceType = store.state.mobile ? 'mobile' : 'pc'
  const type = store.state.theme.type
  const resourceMap = {
    pc: {
      blue: {
        imageSrc: 'https://s.yyjzt.com/kf-web/20241213/1213112000002.png',
        background: 'linear-gradient(180deg, #EBF2FF 0%, #E7DFFF 55%, #F5F4F3 99%)'
      },
      default: {
        imageSrc: 'https://s.yyjzt.com/kf-web/20240416/171325411698039b4.png',
        background: 'linear-gradient(180deg, #FBEEFB 0%, #FDEBE8 55%, #F6F6F6 99%)'
      }
    },

    mobile: {
      blue: {
        imageSrc: 'https://s.yyjzt.com/kf-web/20241212/1733991369619674d.png',
        background: 'https://s.yyjzt.com/kf-web/20241213/1213112000001.png'
      },
      default: {
        imageSrc: 'https://s.yyjzt.com/kf-web/20240613/171824549919681b5.png',
        background: 'https://s.yyjzt.com/kf-web/20240613/1718245503494a3f8.png'
      }
    }
  }

  const deviceResources = resourceMap[deviceType] || resourceMap.pc
  return deviceResources[type] || deviceResources.default
}
